// components/SourceModal.js
import React from "react";

export default function SourceModal({ show, sources, onClose }) {
  if (!show) return null;

  const docPath = process.env.REACT_APP_DOCUMENT_PATH || "";

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
        <div className="custom-modal-header">
          <h4>Sources</h4>
          <button className="custom-close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="custom-modal-body">
          {sources.length > 0 ? (
            <ul className="custom-source-list">
              {sources.map((src, idx) => (
                <li key={idx}>
                  <a
                    href={`${docPath}${src.source}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sourcelabel"
                  >
                    <strong>{src.source}</strong>
                  </a>
                  {src.snippet && <div className="source-snippet">{src.snippet}</div>}
                </li>
              ))}
            </ul>
          ) : (
            <p>No sources available.</p>
          )}
        </div>

        <div className="custom-modal-footer">
          <button className="custom-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
